import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, $state, $stateParams, jsSdkUser, trackingService, partnerService) {
  $scope.citySlug = $stateParams.city || 'bos';

  const validMembershipPlans = ['bos', 'nyc', 'dc'];
  const user = jsSdkUser.getCurrentUser();

  $scope.showAd = function() {
    const isNotOnPartner = partnerService.partner && partnerService.partner.slug === 'www';
    const notPlatinum = (user && user.membershipLevel) ? user.membershipLevel < 25 : true;
    const validCity = validMembershipPlans.includes($scope.citySlug);

    return isNotOnPartner && notPlatinum && validCity;
  };

  $scope.goToMembership = function() {
    trackingService.trackEvent(SEGMENT_EVENTS.TappedFeaturedBanner);

    $state.go('app.membership.landing', {
      city: $scope.citySlug
    });
  };
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'jsSdk.user',
  'trackingService',
  'partnerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/membershipCard/controller.js